import { createUseStyles } from "react-jss";

export default createUseStyles({
  filterBar: {
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
  },
});
